import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Bank } from '@ap/interface-bspc-core';

import { LijstVanDiensten, LijstVanEmailadressen, LijstVanTelefoonnummers } from './digitaal-adres.model';

@Injectable({ providedIn: 'root' })
export class DigitaalAdresResource {
    private readonly baseUrl: string = '/services/apic-digitaal-adres/api';

    public constructor(private readonly httpClient: HttpClient) {}

    public getEmailadressen(bank?: Bank, isVoorkeur?: boolean, klantProspectId?: string): Observable<LijstVanEmailadressen> {
        let httpHeaders = new HttpHeaders();
        let httpParams: HttpParams = new HttpParams();

        if (bank) {
            httpHeaders = httpHeaders.set('X-Bank', bank);
        }

        if (isVoorkeur !== undefined) {
            httpParams = httpParams.set('is_voorkeur', isVoorkeur.toString());
        }

        if (klantProspectId) {
            httpParams = httpParams.set('klant_prospect_id', klantProspectId);
        }

        return this.httpClient.get<LijstVanEmailadressen>(`${this.baseUrl}/emailadressen`, {
            headers: httpHeaders,
            params: httpParams
        });
    }

    public deleteEmailadres(emailId: string): Observable<void> {
        return this.httpClient.delete<void>(`${this.baseUrl}/emailadressen/${emailId}`);
    }

    public getTelefoonnummers(bank?: Bank, isVoorkeur?: boolean, klantProspectId?: string): Observable<LijstVanTelefoonnummers> {
        let httpHeaders = new HttpHeaders();
        let httpParams: HttpParams = new HttpParams();

        if (bank) {
            httpHeaders = httpHeaders.set('X-Bank', bank);
        }

        if (isVoorkeur !== undefined) {
            httpParams = httpParams.set('is_voorkeur', isVoorkeur.toString());
        }

        if (klantProspectId) {
            httpParams = httpParams.set('klant_prospect_id', klantProspectId);
        }

        return this.httpClient.get<LijstVanTelefoonnummers>(`${this.baseUrl}/telefoonnummers`, {
            headers: httpHeaders,
            params: httpParams
        });
    }

    public deleteTelefoonnummer(telefoonId: string): Observable<void> {
        return this.httpClient.delete<void>(`${this.baseUrl}/telefoonnummers/${telefoonId}`);
    }

    public getTelefoonnummerDiensten(telefoonId: string): Observable<LijstVanDiensten> {
        return this.httpClient.get<LijstVanDiensten>(`${this.baseUrl}/telefoonnummers/${telefoonId}/diensten`);
    }

    public getEmailadresDiensten(emailId: string): Observable<LijstVanDiensten> {
        return this.httpClient.get<LijstVanDiensten>(`${this.baseUrl}/emailadressen/${emailId}/diensten`);
    }
}
